import { render, staticRenderFns } from "./grid-relation-settings.vue?vue&type=template&id=2dfd092d&"
import script from "./grid-relation-settings.ts?vue&type=script&lang=js&"
export * from "./grid-relation-settings.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports